export default {
  production: 'PROD',
  partenaire: 'PARTE'
};
